import React from 'react';

const Invantory = () => {
    return (
        <div>
            <h1>Invantory</h1>
        </div>
    );
};

export default Invantory;